import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';
import { ActionConfirmationConfig } from './action-confirmation-modal.config';

@Injectable({ 
  providedIn: 'root' 
})
export class ActionConfirmationService {
  
  constructor(private http: HttpClient) {}
  
  executeAction(config: ActionConfirmationConfig): Observable<any> {
    const url = `${config.baseUrl}/saveJsonObject?action_code=${config.actionCode}`;
    // Build params - merge globalParams first, then filterParams (like original AngularJS)
    // Original pattern: params = _.merge({}, GlobalService.globalParams, filterParams);
    let params: any = _.merge({}, config.globalParams || {}, config.filterParams || {});
    params.sso_id = config.ssoId;
    
    // Apply field mapping
    Object.keys(config.payloadMapping).forEach(apiField => {
      const rowField = config.payloadMapping[apiField];
      params[apiField] = config.rowData[rowField] || '';
    });
    
    // Debug logging
    console.log('ActionConfirmationService - Executing action:', config.actionCode);
    console.log('ActionConfirmationService - globalParams received:', config.globalParams);
    console.log('ActionConfirmationService - filterParams received:', config.filterParams);
    console.log('ActionConfirmationService - Payload params:', params);
    
    // Send based on content type
    if (config.contentType === 'formdata') {
      return this.postFormData(url, params);
    } else {
      return this.postUrlEncoded(url, params);
    }
  }
  
  private postUrlEncoded(url: string, params: any): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({ 
      'Content-Type': 'application/x-www-form-urlencoded' 
    });
    
    return this.http.post<any>(url, urlEncoded.toString(), { 
      headers, 
      withCredentials: true 
    });
  }
  
  private postFormData(url: string, params: any): Observable<any> {
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
    
    return this.http.post<any>(url, formData, { 
      withCredentials: true 
    });
  }
}

